interface WorkersBlockProps {
  workers: number;
  workerDays: number;
  onChange: (value: number) => void;
  onDaysChange: (value: number) => void;
}

export default function WorkersBlock({ workers, workerDays, onChange, onDaysChange }: WorkersBlockProps) {
  const handleWorkersChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = parseInt(e.target.value, 10);
    onChange(!isNaN(val) ? Math.min(50, Math.max(0, val)) : 0);
  };

  const handleDaysChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = parseInt(e.target.value, 10);
    onDaysChange(!isNaN(val) ? Math.min(30, Math.max(1, val)) : 1);
  };

  return (
    <section className="py-8 border-b border-gray-200">
      <h2 className="text-base font-semibold text-gray-900 mb-5">Выбери количество менеджеров, которые будут в твоей команде</h2>

      {/* Количество менеджеров */}
      <div className="flex items-center gap-4">
        <input
          type="number"
          min={0}
          max={50}
          value={workers}
          onChange={handleWorkersChange}
          className="w-24 text-sm text-center border border-gray-200 rounded-md py-2 px-3 text-gray-900 focus:outline-none focus:border-gray-400"
        />
        <span className="text-sm text-gray-400">Оплата в конце месяца по факту</span>
      </div>

      <div className="mt-4 flex items-start gap-2.5 border border-sky-200 rounded-lg px-4 py-3 bg-sky-100">
        <i className="ri-information-line w-4 h-4 flex items-center justify-center text-gray-400 text-base mt-0.5 flex-shrink-0"></i>
        <div className="text-xs text-gray-500 leading-relaxed space-y-1.5">
          <p className="font-medium text-gray-600">Прогрессивная тарификация менеджеров:</p>
          <div className="space-y-1">
            <div className="flex items-baseline gap-2">
              <span className="font-medium text-gray-700 whitespace-nowrap">1–4 менеджера</span>
              <span className="text-gray-400">—</span>
              <span>$2.0/мес за каждого. Стартовый тариф для небольших команд.</span>
            </div>
            <div className="flex items-baseline gap-2">
              <span className="font-medium text-gray-700 whitespace-nowrap">5–10 менеджеров</span>
              <span className="text-gray-400">—</span>
              <span>$1.5/мес за каждого начиная с 5-го. Скидка при росте команды.</span>
            </div>
            <div className="flex items-baseline gap-2">
              <span className="font-medium text-gray-700 whitespace-nowrap">11+ менеджеров</span>
              <span className="text-gray-400">—</span>
              <span>$1.0/мес за каждого начиная с 11-го. Максимальная скидка для крупных команд.</span>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-4">
        <input
          type="range"
          min={0}
          max={50}
          value={workers}
          onChange={handleWorkersChange}
          className="w-full h-1 accent-[#2563EB] cursor-pointer"
        />
        <div className="flex justify-between text-xs text-gray-300 mt-1">
          <span>0</span>
          <span>25</span>
          <span>50</span>
        </div>
      </div>

      {/* Среднее количество дней */}
      <div className="mt-6 pt-5 border-t border-gray-100">
        <div className="flex items-center justify-between mb-3">
          <span className="text-sm font-medium text-gray-700">Среднее кол-во дней существования воркера</span>
          <div className="flex items-center gap-2">
            <input
              type="number"
              min={1}
              max={30}
              value={workerDays}
              onChange={handleDaysChange}
              className="w-16 text-sm text-center border border-gray-200 rounded-md py-1.5 px-2 text-gray-900 focus:outline-none focus:border-gray-400"
            />
            <span className="text-sm text-gray-400">дн.</span>
          </div>
        </div>

        <input
          type="range"
          min={1}
          max={30}
          value={workerDays}
          onChange={handleDaysChange}
          className="w-full h-1 accent-[#2563EB] cursor-pointer"
        />
        <div className="flex justify-between text-xs text-gray-300 mt-1">
          <span>1 дн.</span>
          <span>15 дн.</span>
          <span>30 дн.</span>
        </div>
        <div className="mt-4 flex items-start gap-2.5 border border-sky-200 rounded-lg px-4 py-3 bg-sky-100">
          <i className="ri-information-line w-4 h-4 flex items-center justify-center text-gray-400 text-base mt-0.5 flex-shrink-0"></i>
          <p className="text-xs text-gray-500 leading-relaxed">
            Стоимость менеджеров пересчитывается пропорционально количеству дней: <span className="font-medium text-gray-700">{workerDays}/30</span> от месячной ставки. Например, воркер на 15 дней обойдётся вдвое дешевле полного месяца.
          </p>
        </div>
      </div>
    </section>
  );
}
